import React from 'react';
import Card from 'react-credit-cards';
import {
  Button,
  Card as CardContainer,
  CardActions,
  CardContent,
  CardMedia,
  Icon,
  Typography
} from '@material-ui/core';
import ECheck from './ECheck';


const CreditCard = ({card, setCreditCardData}) => {
  const {card_holder_name, credit_card, master_id} = card;

  const isECheck = card.credit_card.includes('eCheck');
  const ccNumber = !isECheck ? credit_card.split(' - ')[0].replaceAll('x', '*') : credit_card.split(' - ')[0];
  const ccExpiry = !isECheck ? credit_card.split(' - ')[1].split(' ')[1].replaceAll(/\[|\]/g, '') : null;
  const issuer = !isECheck ? credit_card.split(' - ')[1].split(' ')[0] : null;

  const fixedIssuer = (issuer) => {
    if (issuer === 'MC') {
      return 'mastercard';
    }

    if (issuer === 'DISC') {
      return 'discover';
    }

    return issuer;
  };

  return (
    <div>
      <CardContainer elevation={25} className="m-4 min-h-450">
        <CardMedia>
          {!isECheck
            ?   <Card name={card_holder_name} number={ccNumber} expiry={ccExpiry} preview issuer={fixedIssuer(issuer)} />
            :   <ECheck name={card_holder_name} number={ccNumber} />
          }
        </CardMedia>
        <CardContent>
          <Typography variant="h5" className="my-4">Billing Address:</Typography>
          {card.address ?
            <>
              <div className="flex text-muted">
                <Icon className="mr-4" fontSize="small">mail</Icon>
                <div>
                  <Typography variant="body1">
                    {card.address.firstname} {card.address.lastname}
                  </Typography>
                  <Typography variant="body1">
                    {card.address.street.join(' ')}
                  </Typography>
                  <Typography variant="body1">
                    {card.address.city}, {card.address.region.region_code} {card.address.postcode}
                  </Typography>
                  <Typography variant="body1">
                    {card.address.country_id === 'US' ? 'United States' : ''}
                  </Typography>
                </div>
              </div>
              <div className="flex text-muted mt-2">
                <Icon className="mr-4" fontSize="small">phone</Icon>
                <div>
                  <Typography variant="body1">{card.address.telephone}</Typography>
                </div>
              </div>
            </>
            :
            <div className="flex text-muted">
              <Icon className="mr-4" fontSize="small">mail</Icon>
              <div>
                <Typography variant="body1">No Billing Address</Typography>
              </div>
            </div>
          }
        </CardContent>
        {!isECheck &&
          <CardActions className="flex justify-between items-center my-3 px-4">
            <Button
              fullWidth
              variant="outlined"
              className="text-muted"
              onClick={() => setCreditCardData({master_id, action: 'delete'})}
            >
              <Icon className="mr-2">delete_outlined</Icon>
              {'Delete'}
            </Button>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              onClick={() => setCreditCardData({master_id, action: 'replace'})}
            >
              <Icon className="mr-2">cached</Icon>
              {'Replace'}
            </Button>
          </CardActions>
        }
      </CardContainer>
    </div>
  );
};

export default CreditCard;
